import Url from 'url-parse'

type ProviderOption = 'vimeo' | 'youtube' | 'appendee'

type ProcessUrlFn = (string) => string

interface ProviderConfig {
    provider: ProviderOption
    url: string
}

const setSearchParam = (url: string, key: string, value: string) => {
    const urlConstructor = new Url(url, true)
    urlConstructor.query[key] = value
    return urlConstructor.toString()
}

const providerToUrlProcessor: Record<ProviderOption, ProcessUrlFn> = {
    vimeo: (url: string) => setSearchParam(url, 'autoplay', '1'),
    youtube: (url: string) => setSearchParam(url, 'autoplay', '1'),
    appendee: (url: string) => url,
}

const PROVIDER_CONFIG: ProviderConfig[] = [
    {
        provider: 'vimeo',
        url: 'https://player.vimeo.com/',
    },
    {
        provider: 'youtube',
        url: 'https://www.youtube.com/',
    },
    {
        provider: 'youtube',
        url: 'https://youtu.be/',
    },
    {
        provider: 'appendee',
        url: 'https://cdn.elevent.ly/',
    },
    {
        provider: 'appendee',
        url: 'https://cdn.appendee.com/',
    },
]

const getProviderConfig = (streamUrl: string): ProviderConfig | undefined => (
    streamUrl
    && PROVIDER_CONFIG.find(
        ({ url }) => streamUrl.startsWith(url)
    )
)

export const getIsValidStreamUrl = (streamUrl: string) => !!getProviderConfig(streamUrl)

export const processUrl = (streamUrl: string) => {
    const config = getProviderConfig(streamUrl)
    if (!config) { return streamUrl }
    return providerToUrlProcessor[config.provider](streamUrl)
}

export const urlOptions = PROVIDER_CONFIG.map(({ url }) => url)
